<template>
  <footer class="footer">
    <mdb-card class="card-image rounded-0 pb-5 pb-md-0">
      <mdb-container class="mt-5 mb-md-5">
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="footer__heading text-center">
              Do you have any questions or would like to join our network?
            </h2>
          </mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col class="d-flex justify-content-center mt-4">
            <router-link
              :to="{ name: 'Contact' }"
              class="footer__button btn btn-lg"
              >Contact Us</router-link
            >
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center mt-3">
          <mdb-col class="d-flex justify-content-center">
            <p>
              <a href="/legal-notice" class="footer__link">LEGAL NOTICE</a>
              <span class="text-white mx-2">&#124;</span>
              <a href="/data-privacy" class="footer__link">DATA PRIVACY</a>
            </p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-card>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped lang="scss">
@import "~@/styles/components/_footer.scss";
</style>